export class CscUtils {
    enabledProviders: CscProvider[] = [
        new CscProvider('vidua', 'Cleverbase', 'Vidua'),
        new CscProvider('itsme', 'Itsme', 'Itsme'),
        new CscProvider('digidentity', 'Digidentity-global', 'Digidentity-global'),
        new CscProvider('kpn', 'KPN', 'KPN'),
        new CscProvider('primesignmobile', 'PrimeSign', 'primesign')
    ];
}

export class CscProvider {
    id: string;
    name: string;
    apiName: string;
    selected: boolean;

    constructor(id: string, name: string, apiName: string, selected = false) {
        this.id = id;
        this.name = name;
        this.apiName = apiName;
        this.selected = selected;
    }
}
